var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1818 36.0909C51.1818 46.2727 38.0909 55 38.0909 55C38.0909 55 25 46.2727 25 36.0909C25 32.619 26.3792 29.2893 28.8342 26.8342C31.2893 24.3792 34.619 23 38.0909 23C41.5628 23 44.8926 24.3792 47.3476 26.8342C49.8026 29.2893 51.1818 32.619 51.1818 36.0909Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0902 40.4546C40.5002 40.4546 42.4538 38.5009 42.4538 36.0909C42.4538 33.681 40.5002 31.7273 38.0902 31.7273C35.6802 31.7273 33.7266 33.681 33.7266 36.0909C33.7266 38.5009 35.6802 40.4546 38.0902 40.4546Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactmap);
export default __webpack_public_path__ + "static/media/contactmap.554f6745845eded39d113aa1f3e15f6d.svg";
export { ForwardRef as ReactComponent };